import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'margemcontribuicao');

const margemContribuicaoActions = {
  listar: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, margemContribuicaoActions);
